import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import LogoutModal from './LogoutModal';
import DropdownMenuCompact, {DropdownMenuCompactMenuPosition} from '../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import {loggedInUserSelector} from '../../store/selectors/auth.selector';
import DropdownMenuCompactHeader from '../../incase-domain/components/dropdownMenuCompact/header/profile/DropdownMenuCompactProfileHeader';
import Button from '../../incase-domain/components/button/Button';
import {Role} from '../../incase-domain/user';

const ROLE_LABEL: Record<Role, 'roles.superuser' | 'roles.admin' | 'roles.presenter' | 'roles.creator' | 'roles.viewer'> = {
    [Role.SUPERUSER]: 'roles.superuser',
    [Role.ADMIN]: 'roles.admin',
    [Role.PRESENTER]: 'roles.presenter',
    [Role.CREATOR]: 'roles.creator',
    [Role.VIEWER]: 'roles.viewer',
    [Role.USER]: 'roles.viewer',
};

function Profile(): JSX.Element {
    const {t} = useTranslation();
    const user = useSelector(loggedInUserSelector);

    const [modal, setModal] = useState<boolean>(false);

    return (
        <>
            <DropdownMenuCompact
                header={
                    <DropdownMenuCompactHeader
                        subtitle={user?.roles?.[0] ? t(ROLE_LABEL[user.roles[0]]) : ''}
                        title={user?.email || 'Anonymous'}
                    />
                }
                items={[
                    [
                        {
                            label: t('header.logout'),
                            icon: 'ph:sign-out',
                            onClick: () => setModal(true),
                        },
                    ],
                ]}
                menuPosition={DropdownMenuCompactMenuPosition.LEFT}
            >
                <Button leading="solar:user-linear" size="xl" variant="ghost" square />
            </DropdownMenuCompact>

            <LogoutModal isOpen={modal} setOpen={setModal} />
        </>
    );
}

export default Profile;
